import { render, staticRenderFns } from "./createCost.vue?vue&type=template&id=1d52ae44&"
import script from "./createCost.vue?vue&type=script&lang=js&"
export * from "./createCost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports